import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Stack from '@mui/material/Stack';
import { Snackbar, Alert } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import SignInCard from './SignInCard';
import AppTheme from '../shared-theme/AppTheme';
import ColorModeSelect from '../shared-theme/ColorModeSelect';
import { useAuth } from '../components/AuthContext';
import { useEffect, useState } from 'react';

export default function SignInSide(props) {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [notice, setNotice] = useState('');

  useEffect(() => {
    if (isAuthenticated && !location.state?.from) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, navigate, location]);

  useEffect(() => {
    if (location.state?.successMessage) {
      setNotice(location.state.successMessage);
      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate]);

  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <ColorModeSelect sx={{ position: 'fixed', top: '1rem', right: '1rem' }} />
      <Stack
        direction="column"
        component="main"
        sx={[
          {
            justifyContent: 'center', // Center vertically
            alignItems: 'center',    // Center horizontally
            minHeight: '100%',       // Ensure it occupies the full screen
            padding: 2,
          },
          (theme) => ({
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              zIndex: -1,
              inset: 0,
              backgroundImage:
                'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
              backgroundRepeat: 'no-repeat',
              ...theme.applyStyles('dark', {
                backgroundImage:
                  'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
              }),
            },
          }),
        ]}
      >
        <SignInCard />
      </Stack>
      <Snackbar
        open={!!notice}
        autoHideDuration={4000}
        onClose={() => setNotice('')}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setNotice('')} severity="success" sx={{ width: '100%' }}>
          {notice}
        </Alert>
      </Snackbar>
    </AppTheme>
  );
}
